module.exports = __webpack_public_path__ + "c593d43a59596493c752a08fe1404e1b.svg";